export default "__VITE_ASSET__2d8b1287__"